// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import css from './items.css'
type IncentiveProductsListProps = {
  data: Array<string>
  emptyText: string
}

const IncentiveProductsList = ({ data, emptyText }: IncentiveProductsListProps) => (
  <div className={css.itemList}>
    {data.length > 0 ? (
      <table className={css.table} cellPadding={0} cellSpacing={0}>
        <tbody className={css.isList}>
          {data.map((value, i) => (
            <tr key={i}>
              <td>{value.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p className={css.emptyText}>{emptyText}</p>
    )}
  </div>
)

type IncentiveProductsProps = {
  data: Array<string>
  emptyText: string
}

const IncentiveSaleProducts = ({ data, emptyText }: IncentiveProductsProps) => (
  <div className={css.component}>
    <IncentiveProductsList data={data} emptyText={emptyText} />
  </div>
)

export default IncentiveSaleProducts
